var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIrelandFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M256.001 19.596c65.278 0 124.383 26.466 167.162 69.243 42.777 42.779 69.243 101.884 69.243 167.162s-26.466 124.383-69.246 167.16c-42.776 42.779-101.881 69.245-167.159 69.245-65.278 0-124.383-26.466-167.162-69.242-42.777-42.78-69.243-101.885-69.243-167.163S46.062 131.618 88.839 88.839c42.779-42.777 101.884-69.243 167.162-69.243z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#169B62",
    d: "M175.454 55.093V456.91c-79.628-31.951-135.86-109.858-135.86-200.909 0-91.05 56.232-168.954 135.86-200.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M336.574 55.105v401.793c-24.905 9.999-52.094 15.51-80.573 15.51-28.471 0-55.648-5.505-80.547-15.498V55.093c24.899-9.99 52.076-15.499 80.547-15.499 28.479 0 55.668 5.512 80.573 15.511z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF883E",
    d: "M336.574 456.898V55.105c79.61 31.96 135.834 109.855 135.834 200.896 0 91.039-56.224 168.937-135.834 200.897z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrelandFlag);
export default __webpack_public_path__ + "static/media/irelandFlag.ce08db7f91c5d82fe1accfeeb6939455.svg";
export { ForwardRef as ReactComponent };